import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import { formatRupiah } from "component/utils/formatRupiah";

function AddBooking() {
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [item, setItem] = useState(null);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    accountHolder: "",
    bankFrom: "",
    total: "",
    discount: "",
    sales: "",
    breakfast: ""
  });
  const passedItem = location.state?.item;
  const passedCategory = location.state?.category;

  const parseDDMMYYYY = (str) => {
    const [day, month, year] = str.split("-");
    return new Date(`${year}-${month}-${day}`);
  };

  const toFullTimestamp = (str, time = "00:00:00") => {
    const [day, month, year] = str.split("-");
    return `${year}-${month}-${day} ${time}`;
  };

  const bookingStartDate = searchParams.get("start_date");
  const bookingEndDate = searchParams.get("end_date");
  const categoryId = searchParams.get("category_id");
  const start = parseDDMMYYYY(bookingStartDate);
  const end = parseDDMMYYYY(bookingEndDate);
  let duration = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

  if (categoryId === "CAT-GEDUNG") {
    duration += 1; // Tambah 1 hari karena hari awal juga dihitung
  }

  const [formattedDiscount, setFormattedDiscount] = useState("");
  const [subTotal, setSubTotal] = useState(0);
  // const [total, setTotal] = useState(0);
  
  useEffect(() => {
    if (passedItem) {
      setItem({
        ...passedItem,
        categoryId: passedCategory?.categoryId || "",
        categoryName: passedCategory?.categoryName || ""
      });
    }
  }, [passedItem, passedCategory]);

  // useEffect(() => {
  //   fetchItem();
  // }, []);

  // const fetchItem = async () => {
  //   try {
  //     const res = await axios.get(
  //       `${process.env.REACT_APP_API}/item/${id}`
  //     );
  //     setItem(res.data.data[0]);
  //     const subtotal = res.data.data[0].price * duration;
  //     const tax = subtotal * 0.1;
  //     setSubTotal(subtotal);
  //     setTotal(subtotal + tax);
  //   } catch (err) {
  //     console.error("Gagal mengambil data item", err);
  //   }
  // };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDiscountChange = (e) => {
    const rawValue = e.target.value;
    const numberValue = rawValue.replace(/\D/g, ""); // hanya angka

    setForm({ ...form, discount: numberValue });
    setFormattedDiscount(formatRupiah(numberValue));
  };

  useEffect(() => {
    if (item) {
      const subtotal = item.price;
      const discountValue = parseInt(form.discount || 0);
      const totalWithDiscount = subtotal - discountValue;

      setForm({ ...form, total: totalWithDiscount });
    }
  }, [form.discount, item]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const confirmed = await showConfirm({
      title: 'Konfirmasi Booking',
      text: `Apakah Anda yakin ingin melakukan booking item ${item.title}?`,
      confirmButtonText: 'Ya, Booking'
    });

    if (!confirmed) return;

    const formData = new FormData();
    formData.append("idItem", id);
    formData.append("duration", duration);
    formData.append("bookingStartDate", toFullTimestamp(bookingStartDate, "14:00:00"));
    formData.append("bookingEndDate", toFullTimestamp(bookingEndDate, "12:00:00"));
    formData.append("firstName", form.firstName);
    formData.append("lastName", form.lastName);
    formData.append("email", form.email);
    formData.append("phoneNumber", form.phoneNumber);
    formData.append("accountHolder", form.accountHolder);
    formData.append("bankFrom", form.bankFrom);
    formData.append("discount", form.discount || "0");
    // formData.append("tax", tax);
    formData.append("total", form.total);
    formData.append("sales", form.sales);
    formData.append("breakfast", form.breakfast);

    const fileName = form.bankFrom === "cash" ? "cash.jpg" : "transfer.jpg";
    const response = await fetch(`/assets/img/${fileName}`);
    const blob = await response.blob();
    const file = new File([blob], fileName, { type: blob.type });
    formData.append("image", file);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/booking-page`, formData);
      showSuccess(response.data.message || "Booking berhasil");
      navigate("/new-booking");
    } catch (err) {
      console.error("Gagal booking", err);
      showError(err.response?.data?.message || "Gagal booking item");
    }
  };

  if (!item) return <div>Loading...</div>;

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row px-4">
                <div className="card shadow p-3 mb-4">
                  <h5 className="card-title mb-4">Form Booking</h5>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-3 my-1">
                        <label>Category</label>
                        <input type="text" className="form-control" value={item.categoryName} readOnly />
                      </div>
                      <div className="col-3 my-1">
                        <label>Item</label>
                        <input type="text" className="form-control" value={item.title} readOnly />
                      </div>
                      <div className="col-3 my-1">
                        <label>Start Booking</label>
                        <input type="text" className="form-control" value={bookingStartDate} readOnly />
                      </div>
                      <div className="col-3 my-1">
                        <label>End Booking</label>
                        <input type="text" className="form-control" value={bookingEndDate} readOnly />
                      </div>
                      <div className="col-3 my-1">
                        <label>Duration</label>
                        <input type="text" className="form-control" value={duration} readOnly />
                      </div>
                      <div className="col-3 my-1">
                        <label>Sub Total</label>
                        <input type="text" className="form-control" value={`Rp ${item.price.toLocaleString("id-ID")}`} readOnly />
                      </div>
                      {/* <div className="col-3 my-1">
                        <label>Tax</label>
                        <input type="text" className="form-control" value="10%" readOnly />
                      </div> */}
                      <div className="col-3 my-1">
                        <label>Diskon</label>
                        <input
                          type="text"
                          className="form-control"
                          name="discount"
                          value={formattedDiscount}
                          onChange={handleDiscountChange}
                          placeholder="Masukkan jumlah diskon"
                        />
                      </div>
                      <div className="col-3 my-1">
                        <label>Total</label>
                        <input type="text" className="form-control" value={`Rp ${form.total.toLocaleString("id-ID")}`} readOnly />
                      </div>

                      {/* {item.categoryId !== "CAT-HOTEL" && (
                        <div className="col-6 my-1">
                          <label>Diskon</label>
                          <input
                            type="text"
                            className="form-control"
                            name="discount"
                            value={formattedDiscount}
                            onChange={handleDiscountChange}
                            placeholder="Masukkan jumlah diskon"
                          />
                        </div>
                      )} */}
                    </div>
                    <div className="row">
                      {item.categoryId == "CAT-HOTEL" ? (
                      <div className="col-3 my-1">
                          <label>Breakfast</label>
                          <select className="form-control" name="breakfast" required onChange={handleChange}>
                            <option value="">-- Pilih Breakfast --</option>
                            <option value="Y">Ya</option>
                            <option value="T">Tidak</option>
                          </select>
                      </div>
                      ) : (
                        <div className="col-3 my-1">
                          <label>Catering</label>
                          <select className="form-control" name="breakfast" required onChange={handleChange}>
                            <option value="">-- Pilih Catering --</option>
                            <option value="Y">Ya</option>
                            <option value="T">Tidak</option>
                          </select>
                      </div>
                      )}
                      <div className="col-5 my-1">
                        <label>Marketing</label>
                        <input type="text" className="form-control" name="sales" required onChange={handleChange} />
                      </div>
                      <div className="col-6 my-1">
                        <label>First Name</label>
                        <input type="text" className="form-control" name="firstName" required onChange={handleChange} />
                      </div>
                      <div className="col-6 my-1">
                        <label>Last Name</label>
                        <input type="text" className="form-control" name="lastName" required onChange={handleChange} />
                      </div>
                      <div className="col-6 my-1">
                        <label>Email</label>
                        <input type="email" className="form-control" name="email" required onChange={handleChange} />
                      </div>
                      <div className="col-6 my-1">
                        <label>Phone Number</label>
                        <input type="text" className="form-control" name="phoneNumber" required onChange={handleChange} />
                      </div>
                      <div className="col-6 my-1">
                        <label>Nama Pengirim</label>
                        <input type="text" className="form-control" name="accountHolder" required onChange={handleChange} />
                      </div>
                      <div className="col-6 my-1">
                        <label>Asal Bank</label>
                        <select className="form-control" name="bankFrom" required onChange={handleChange}>
                          <option value="">-- Pilih Metode Pembayaran --</option>
                          <option value="cash">Cash</option>
                          <option value="transfer">Transfer</option>
                        </select>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mb-3">
                      <button type="submit" className="btn btn-primary m-3">Booking</button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm m-3"
                        onClick={() => navigate(-1)}
                      >
                        ← Kembali
                      </button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
    </div>
  );
}

export default AddBooking;
